import React, { useEffect, useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../app/hooks';
import { useUpsertRuleMutation, useDeleteRuleMutation, contractApi } from '../../../../../services/ContractService';
import { RuleCommands } from './RuleCommands';

interface ApcCarveOutsProps {
  ruleId: string;
  ruleString?: string;
  ruleDescription?: string;
}

interface ApcCarveOutRule {
  code: string;
  description: string;
  price: number;
}

const ApcCarveOuts: React.FC<ApcCarveOutsProps> = ({ ruleId, ruleString = '', ruleDescription = '' }) => {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get('id');
  const dispatch = useAppDispatch();
  const [rule, setRule] = useState<ApcCarveOutRule>({ code: '', description: '', price: 0 });
  const [upsertRule] = useUpsertRuleMutation();
  const [deleteRule] = useDeleteRuleMutation();

  const save = async () => {
    if (!contractId) return;
    
    try {
      await upsertRule({
        contractId: contractId,
        ruleId,
        ruleType: 'ApcCarveouts',
        priority: 0,
        ruleString: JSON.stringify(rule),
        description: ruleDescription || ''
      }).unwrap();
      
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to save rule:', error);
    }
  };

  const ruleDelete = async () => {
    try {
      await deleteRule({ ruleId }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to delete rule:', error);
    }
  };

  useEffect(() => {
    if (ruleString && ruleString !== '') {
      try {
        const parsedRule: ApcCarveOutRule = JSON.parse(ruleString);
        setRule(parsedRule);
      } catch (error) {
        console.error('Failed to parse rule string:', error);
      }
    }
  }, [ruleString, ruleId]);

  return (
    <>
      <Stack direction="row" gap={1}>
        <TextField
          label="Code"
          size="small"
          value={rule.code}
          onChange={(e) => setRule({ ...rule, code: e.target.value })}
          sx={{ width: '100px' }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Description"
          size="small"
          value={rule.description}
          onChange={(e) => setRule({ ...rule, description: e.target.value })}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          type="number"
          label="Conv. Price"
          size="small"
          value={rule.price}
          onChange={(e) => setRule({ ...rule, price: Number(e.target.value) })}
          sx={{ width: '100px' }}
          inputProps={{ step: 0.01 }}
          InputLabelProps={{ shrink: true }}
        />
      </Stack>
      <RuleCommands
        saveCommand={save}
        deleteCommand={ruleDelete}
        isNewRule={ruleId === '0'}
      />
    </>
  );
};

export { ApcCarveOuts };